import ApplicationStyles from 'app/styles/ApplicationStyles';
import { Colors, Metrics } from 'app/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    paper: {
        padding: theme.spacing(1),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    button: {
        marginLeft: 8,
        marginTop: 15
    },
    content: {
        flexGrow: 1,
        // paddingBottom: 1,
        // height: '100vh',
        overflow: 'auto',
    },
    tab: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    fill: {
        height: 20,
        width: 20,
        borderRadius: 20,
        color: Colors.primary,
        backgroundColor: Colors.primary
    },
    empty: {
        borderRadius: 20,
        height: 20,
        width: 20,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: Colors.primary,
    },
    deleteIcon: {
        color: Colors.red,
        fontSize: 20,
    },
    editIcon: {
        color: Colors.primary,
        fontSize: 20,
    },
    buttons: {
        display: 'flex',
        flexDirection: 'row',
    },
    gridSeparatorRight: {
		paddingRight: '1%',
	},
	gridSeparatorLeft: {
		paddingLeft: '1%',
	},
	gridSeparatorTop: {
		paddingTop: '16px',
    },
    tabContainer: {
        'marginLeft': Metrics.baseMargin,
        'marginRight': Metrics.baseMargin,
        'marginTop': Metrics.baseMargin,
        'marginBottom': 0,
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
    },
    example: {
        padding: '30px 50px',
        background: 'rgba(0, 0, 0, 0.25)',
        textAlign: 'center',
        borderRadius:' 4px',
        marginBottom: '20px',
        width: '100%',
        height: '100%',
        display: 'flex',
        position: 'fixed',
        alignItems: 'center',
        zIndex: '1000',
        justifyContent: 'space-around',
    },
}));

export const styles = ({
    // ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
    titleBox: {
        ...ApplicationStyles.margins.baseHorizontalMargin,
        // ...ApplicationStyles.margins.smallVerticalMargin
    },
    inputSelect: {
        width: '100%',
        paddingRight: 8,
        paddingBottom: 5,
    }
})